import React from 'react';
export function BeforeAfterIndoor() {
  return <section className="bg-warm-mid py-16 md:py-20 px-4" data-id="element-32">
      <div className="max-w-4xl mx-auto" data-id="element-33">
        {/* Section label */}
        <p className="font-sans font-medium text-soft-gold uppercase tracking-wider text-xs md:text-sm text-center mb-3" data-id="element-34">
          See the difference simple guidance makes
        </p>

        {/* Before / After Image Comparison */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-8" data-id="element-35">
          {/* Before */}
          <div className="relative rounded-2xl overflow-hidden shadow-lg" data-id="element-36">
            <img src="https://cdn.magicpatterns.com/uploads/4iLQCfFCvK9tmuiCCbyQpg/ChatGPT_Image_Mar_20,_2026,_09_00_40_PM.png" alt="Before: Dachshund indoors with basic lighting, busy background and casual composition" className="w-full h-64 md:h-80 object-cover" data-id="element-37" />
            <div className="absolute top-3 left-3 bg-red-500/90 text-white font-sans font-bold text-xs uppercase tracking-wider px-3 py-1.5 rounded-full" data-id="element-38">
              Before
            </div>
          </div>

          {/* After */}
          <div className="relative rounded-2xl overflow-hidden shadow-xl ring-2 ring-soft-gold/30" data-id="element-39">
            <img src="https://cdn.magicpatterns.com/uploads/n8Qpp3PxidQCK5iekU8c7Z/ChatGPT_Image_Mar_20,_2026,_09_00_32_PM.png" alt="After: Dachshund indoors with warm natural light, soft background, cozy composition and heartwarming expression" className="w-full h-64 md:h-80 object-cover" data-id="element-40" />
            <div className="absolute top-3 left-3 bg-green-600/90 text-white font-sans font-bold text-xs uppercase tracking-wider px-3 py-1.5 rounded-full" data-id="element-41">
              After
            </div>
          </div>
        </div>

        {/* Text below */}
        <p className="font-sans text-lg md:text-xl text-gray-800 text-center max-w-2xl mx-auto leading-relaxed" data-id="element-42">
          The problem is usually not your dog. It's{' '}
          <span className="font-semibold text-warm-hero" data-id="element-43">
            light, angle, composition
          </span>
          , and knowing what to do in the moment.
        </p>
      </div>
    </section>;
}